/**
 * GameGrid — the top of the shop tree: a 2-column grid of game tiles (DESIGN frame 02).
 *
 * Games returned by the API are active and orderable; a trailing dashed tile signals
 * that more games are on the way.
 */
import { GameCard, useGames, type Game } from "@entities/game";

import { StatePanel } from "./StatePanel";
import styles from "./CatalogBrowser.module.css";

export interface GameGridProps {
  readonly onSelect: (game: Game) => void;
}

export function GameGrid({ onSelect }: GameGridProps): JSX.Element {
  const { data, isLoading, error, refetch } = useGames();

  if (isLoading) {
    return <StatePanel kind="loading" />;
  }
  if (error) {
    return <StatePanel kind="error" onRetry={refetch} />;
  }
  if (!data || data.length === 0) {
    return <StatePanel kind="empty" message="Игры скоро появятся" />;
  }

  return (
    <div className={styles.gameGrid}>
      {data.map((game) => (
        <GameCard key={game.id} game={game} onSelect={onSelect} />
      ))}
      <div className={styles.gameSoon} aria-hidden="true">
        <span className={styles.gameSoonPlus}>+</span>
        <span className={styles.gameSoonText}>
          Другие игры
          <br />
          скоро
        </span>
      </div>
    </div>
  );
}
